export default __webpack_public_path__ + "static/media/R&J Dental Board Logo.00f4e108.png";